// extracted by mini-css-extract-plugin
export var alignCenter = "EEc66O8NfFq5EqkGkRfQ";
export var alignRight = "bmzQorIVYts03d9ax7l9";
export var cell = "TyaDViXNTL84qabDmu8z";
export var clickable = "mT7WoNf7WYch3S1vRefE";
export var headCell = "a7kFRawUYfnTgnTRS2kC";
export var row = "DqelEM5H4UfjGmlSNcoL";
export var table = "zw1GkeaCjAqx8B5AiRMc";
export var tableHead = "T_WBkfpAa8NHZn2d7968";